import { colors } from '&assets/constants/colors';
import { device } from '&assets/constants/responsiveness';
import styled from 'styled-components';

interface Props {
	isWhite?: boolean;
}
export const SubmitButtonWrapper = styled.button<Props>`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 25px 0px;
	width: fit-content;
	padding-left: 2rem;
	padding-right: 2rem;
	height: 40px;
	background: ${(props) => (props.isWhite ? colors.white : colors.primary)};
	border: 0;
	${(props) => (props.disabled ? 'opacity: 0.5;' : '')}
	cursor: ${(props) => (props.disabled ? 'initial' : 'pointer')};
	.btn-title {
		font-size: 17px;
		line-height: 160%;
		text-align: center;
		color: ${(props) => (props.isWhite ? colors.primary : colors.white)};
		white-space: nowrap;
	}

	.icon-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 5px;
	}
	.MuiCircularProgress-circle {
		color: ${colors.white};
	}

	@media ${device.tablet} {
		min-width: 99px;
	}

	@media ${device.mobile} {
		min-width: 99px;
		.title {
			font-size: 14px;
		}
	}
`;
